import { TypoFootnote } from '@/components/Typography.tsx';

/**
 * The reCAPTCHA badge is `position: fixed` bottom-right and overlaps content on
 * a phone, so it is hidden below 640px (see `index.css`). Google's terms require
 * the attribution to stay visible, so it moves into the form footer on mobile.
 */
const RecaptchaNotice = () => (
  <p className="m:block hidden px-4 py-3 text-center">
    <TypoFootnote className="text-neutral-text-softer">
      This site is protected by reCAPTCHA and the Google{' '}
      <a className="underline" href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
      <a className="underline" href="https://policies.google.com/terms">Terms of Service</a> apply.
    </TypoFootnote>
  </p>
);

export default RecaptchaNotice;
